// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__5X4lK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__314PU"};